import React from "react";
import {WithTranslation, withTranslation} from "react-i18next";
import UninstallEquipment from "../../../models/operations/UninstallEquipment";

/**
* Interface inheriting the translation module.
* We put all the props of the component there.
**/
interface Props extends WithTranslation {
    /**
     * Operation to display
     */
    operation: UninstallEquipment;
}

/**
 * Displays the attributes specific to the uninstallation of equipment.
 * @author Alizée Grand
 * @version 1.1
 * @creation 29/06/2022
 * @last_update 11/07/2022
 **/
class DisplayEquipmentUninstallation extends React.Component<Props> {

    render() {

        /**
        * Retrieves from the props the function to access the translation.
        **/
        const getTranslation = this.props.t;

        return (

            <React.Fragment>
                <span><b>{getTranslation("display.operation.equipment-uninstallation.equipment-id")}</b> : {this.props.operation.equipmentId}</span>
                <br/>
            </React.Fragment>

        );

    };

}

export default withTranslation()(DisplayEquipmentUninstallation);
